<div class="flex progress-wrap" nz-popover [nzPopoverPlacement]="'top'"
[nzPopoverContent]="deliveryTemplate" *ngIf="!cancelled">
  <div class="delivered" [ngClass]="{'box-shadow':delivered!=0 && (beProcessed||open)!=0}" [style.width.%]="(delivered/total)*100">{{delivered}}</div>
  <div class="processed" [ngClass]="{'box-shadow':open!=0 && beProcessed!=0}" [style.width.%]="(beProcessed/total)*100">{{beProcessed}}</div>
  <div class="open" [style.width.%]="(open/total)*100">{{open}}</div>
</div>
<ng-template #deliveryTemplate>
  <div>
    <div class="flex-center" >
      <div>
        <span class="delivered-icon"></span>
        <span class="info-title font14-w500">{{"COMPLETED" | translate}}</span>
      </div>
      <span class="color-grey font14-w500">{{delivered}}</span>
    </div>
    <div class="flex-center">
      <div>
        <span class="processed-icon"></span>
        <span class="info-title font14-w500">{{"BEING_PROCESSED" | translate}}</span>
      </div>
      <span class="color-grey font14-w500">{{beProcessed}}</span>
    </div>
    <div class="flex-center">
      <div>
        <span class="open-icon"></span>
        <span class="info-title font14-w500">{{"OPEN" | translate}}</span>
      </div>
      <span class="color-grey font14-w500">{{open}}</span>
    </div>
  </div>
</ng-template>
<div class="progress-wrap" *ngIf="cancelled">
  <div class="cancelled"></div>
</div>
